export function SwitchComponent({ on, off, state }) {
  return state ? on || null : off || null;
}

export default SwitchComponent;
